const navbar = {
  packages: "संकुल", // translated 
  hotelPackages: "होटल पैकेज", // translated 
  experiences: "अनुभव", // translated 
  close: "बंद करना", // translated 
  hotDeals: "जबरदस्त सौदे", // translated 
  dashboard: "डैशबोर्ड", // translated 
  pricing: "मूल्य निर्धारण", // translated 
};


export default navbar;
